import API from '@/models/API';
import pointsRelation from '@/utils/translations/loyaltyPanel/businessProfile/pointsRelation';

export default class BusinessProfile {
  static uploadImage = (image) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/settings/upload-images`, image);

  static uploadLoyaltyImage = (image) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/settings/upload-loyalty-image`, image);

  static getProfileData = (profile) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/settings/all`, profile);

  static getUserManual = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/settings/upload-file`, file);

  static getTermFile = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/settings/upload-file`, file);

  static getPrivacyFile = (file) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/settings/upload-file`, file);

  static putInitialPoint = (points) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/settings/init-user-points`, points);

  static updatePointRelation = (pointsRelation) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/online-offline-points-ratio`,
      pointsRelation
    );

  static updateUserPointVisibility = (userPoint) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/app-points-visibility`,
      userPoint
    );

  static updateCoupon = (couponCreation) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/coupon-creation-type-id`,
      couponCreation
    );

  static updatePointReturn = (returnPoint) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/return-points-after-coupon-exp`,
      returnPoint
    );

  static updateShowLoyalty = (showLoyalty) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/visible-loyalty-program`,
      showLoyalty
    );

  static updatePushNotification = (pushNotification) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/push_notifications`,
      pushNotification
    );

  static updateCredential = (campaignEmailMethod) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/campaign-email-notifications`,
      campaignEmailMethod
    );

  static updateCampaignEmailNotifications = (body) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/campaign-email-notifications`,
      body
    );

  static updateSmsConfiguration = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/settings/sms-configuration`, body);

  static updateSmsRedemption = (body) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/sms-coupon-claim-message`,
      body
    );

  static updateEmailConfiguration = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/settings/email-configuration`, body);

  static emailSmsSetting = (campaignCredential) =>
    API.put(
      `/companies/${localStorage.getItem('storeId')}/settings/email-sms-settings`,
      campaignCredential
    );

  static updateCouponClaimValidDays = (body) =>
    API.post(`/companies/${localStorage.getItem('storeId')}/coupon-claim/valid-days`, body);
  static updateTiersSettings = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/tiers/change`, body);

  static updateCompanyName = (body) =>
    API.patch(`/companies/${localStorage.getItem('storeId')}/settings/update-name`, body);
  static elasticEmailValidation = (body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/settings/elastic-email-validation`,
      body
    );
  static updateExpirationPoints = (body) =>
    API.patch(
      `/companies/${localStorage.getItem('storeId')}/settings/update-expiration-points`,
      body
    );

  static viberAliasRequest = (body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/settings/viber-alias-name-request`,
      body
    );
  static viberAliasConfirm = (body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/settings/viber-alias-name-confirm`,
      body
    );
  static viberAliasCancel = (body) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/settings/viber-alias-name-cancel`,
      body
    );
  static updateVatNumber = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/store-billing/vat-number`, body);
  static updateElorusClient = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/store-billing/elorus-client`, body);
  static updateVatPercentage = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/store-billing/vat-percentage`, body);
  static updateDisplayMode = (body) =>
    API.put(`/companies/${localStorage.getItem('storeId')}/settings/display-mode`, body);
}
